<script setup lang="ts">
import { ref } from "vue";
import TourCard from "@/components/tours/TourCard.vue";
defineProps(["tours"]);
const activeTour = ref(null as string | null);
const setActiveTour = (index: string) => {
  activeTour.value = index;
};
</script>
<template>
  <div id="orders" class="flex flex-col gap-3 pb-[150px]">
    <TourCard
      v-for="(tour, index) in tours"
      :key="index"
      :index="index"
      :order="tour"
      :active-order="activeTour"
      @activeOrder="setActiveTour"
    ></TourCard>
  </div>
</template>
